/* © NXAPP Limited */

export interface SicCode {
  code: string
  label: string
  group: string
}

export const SIC_CODES: SicCode[] = [
  // Tech & Software
  { code: '62012', label: 'Business and domestic software development', group: 'Tech & Software' },
  { code: '62020', label: 'Information technology consultancy activities', group: 'Tech & Software' },
  { code: '62090', label: 'Other IT and computer service activities', group: 'Tech & Software' },
  { code: '63110', label: 'Data processing, hosting and related activities', group: 'Tech & Software' },
  { code: '63120', label: 'Web portals', group: 'Tech & Software' },
  { code: '58290', label: 'Other software publishing', group: 'Tech & Software' },
  { code: '58210', label: 'Publishing of computer games', group: 'Tech & Software' },
  // Professional Services
  { code: '69201', label: 'Accounting and auditing activities', group: 'Professional Services' },
  { code: '69202', label: 'Bookkeeping activities', group: 'Professional Services' },
  { code: '70229', label: 'Management consultancy (excl. financial)', group: 'Professional Services' },
  { code: '70221', label: 'Financial management', group: 'Professional Services' },
  { code: '73110', label: 'Advertising agencies', group: 'Professional Services' },
  { code: '73120', label: 'Media representation services', group: 'Professional Services' },
  { code: '74909', label: 'Other professional, scientific and technical activities', group: 'Professional Services' },
  { code: '74100', label: 'Specialised design activities', group: 'Professional Services' },
  { code: '71111', label: 'Architectural activities', group: 'Professional Services' },
  { code: '71121', label: 'Engineering design activities for industrial process & production', group: 'Professional Services' },
  { code: '69101', label: 'Barristers at law', group: 'Professional Services' },
  { code: '69102', label: 'Solicitors', group: 'Professional Services' },
  // Finance & Investment
  { code: '64191', label: 'Banks', group: 'Finance & Investment' },
  { code: '64205', label: 'Activities of financial services holding companies', group: 'Finance & Investment' },
  { code: '64301', label: 'Activities of investment trusts', group: 'Finance & Investment' },
  { code: '64302', label: 'Activities of unit trusts', group: 'Finance & Investment' },
  { code: '64999', label: 'Financial intermediation not elsewhere classified', group: 'Finance & Investment' },
  { code: '66110', label: 'Administration of financial markets', group: 'Finance & Investment' },
  { code: '66120', label: 'Security and commodity contracts brokerage', group: 'Finance & Investment' },
  { code: '66190', label: 'Activities auxiliary to financial services', group: 'Finance & Investment' },
  // Real Estate & Property
  { code: '68100', label: 'Buying and selling of own real estate', group: 'Real Estate' },
  { code: '68201', label: 'Renting and operating of housing association real estate', group: 'Real Estate' },
  { code: '68209', label: 'Other letting and operating of own or leased real estate', group: 'Real Estate' },
  { code: '68310', label: 'Real estate agencies', group: 'Real Estate' },
  { code: '68320', label: 'Management of real estate on a fee or contract basis', group: 'Real Estate' },
  // Construction
  { code: '41100', label: 'Development of building projects', group: 'Construction' },
  { code: '41201', label: 'Construction of commercial buildings', group: 'Construction' },
  { code: '41202', label: 'Construction of domestic buildings', group: 'Construction' },
  { code: '43120', label: 'Site preparation activities', group: 'Construction' },
  { code: '43210', label: 'Electrical installation', group: 'Construction' },
  { code: '43220', label: 'Plumbing, heat and air-conditioning installation', group: 'Construction' },
  { code: '43290', label: 'Other construction installation activities', group: 'Construction' },
  { code: '43310', label: 'Plastering', group: 'Construction' },
  { code: '43320', label: 'Joinery installation', group: 'Construction' },
  { code: '43330', label: 'Floor and wall covering', group: 'Construction' },
  { code: '43341', label: 'Painting', group: 'Construction' },
  { code: '43342', label: 'Glazing', group: 'Construction' },
  // Retail & E-commerce
  { code: '47910', label: 'Retail sale via mail order houses or Internet', group: 'Retail & E-commerce' },
  { code: '47990', label: 'Other retail sale not in stores, stalls or markets', group: 'Retail & E-commerce' },
  { code: '46900', label: 'Non-specialised wholesale trade', group: 'Retail & E-commerce' },
  // Health & Wellbeing
  { code: '86101', label: 'Hospital activities', group: 'Health & Wellbeing' },
  { code: '86210', label: 'General medical practice activities', group: 'Health & Wellbeing' },
  { code: '86900', label: 'Other human health activities', group: 'Health & Wellbeing' },
  { code: '88100', label: 'Social work activities without accommodation for the elderly and disabled', group: 'Health & Wellbeing' },
  { code: '96020', label: 'Hairdressing and other beauty treatment', group: 'Health & Wellbeing' },
  // Education & Training
  { code: '85590', label: 'Other education not elsewhere classified', group: 'Education' },
  { code: '85600', label: 'Educational support services', group: 'Education' },
  { code: '85520', label: 'Cultural education', group: 'Education' },
  // Hospitality & Food
  { code: '56101', label: 'Licensed restaurants', group: 'Hospitality' },
  { code: '56102', label: 'Unlicensed restaurants and cafes', group: 'Hospitality' },
  { code: '55100', label: 'Hotels and similar accommodation', group: 'Hospitality' },
  { code: '56210', label: 'Event catering activities', group: 'Hospitality' },
  // Transport & Logistics
  { code: '49410', label: 'Freight transport by road', group: 'Transport & Logistics' },
  { code: '52290', label: 'Other transportation support activities', group: 'Transport & Logistics' },
  { code: '53202', label: 'Unlicensed carriers', group: 'Transport & Logistics' },
  // Holding & Investment Companies
  { code: '64203', label: 'Activities of construction holding companies', group: 'Holdings' },
  { code: '64204', label: 'Activities of distribution holding companies', group: 'Holdings' },
  { code: '64209', label: 'Activities of other holding companies', group: 'Holdings' },
]

export const SIC_GROUPS = Array.from(new Set(SIC_CODES.map(s => s.group)))
